module.exports = __webpack_public_path__ + "media/images/home-page/3-2-2ea2101fe84c3241c39efdc1e0ce5b0f.png";